import {
  Box,
  styled,
  Switch,
  switchClasses,
  Tooltip,
  Typography,
} from "@mui/material"
import { useFlags } from "launchdarkly-react-client-sdk"
import { useUserPreferences } from "../../contexts/UserPreferencesContext"
import { extraColors } from "../../utils/theme"

const ToggleRow = styled("div")({
  display: "flex",
  alignItems: "center",
})

const SwitchStyled = styled(Switch)({
  [`& .${switchClasses.switchBase}.Mui-checked`]: {
    color: extraColors.status.navy,
  },
  [`& .${switchClasses.switchBase}.Mui-checked + .${switchClasses.track}`]: {
    backgroundColor: extraColors.status.navy,
  },
  [`& .${switchClasses.switchBase}`]: {
    color: extraColors.status.green,
  },
  [`& .${switchClasses.switchBase} + .${switchClasses.track}`]: {
    color: extraColors.status.green,
    backgroundColor: extraColors.status.green,
  },
})

export const NullDataToggle: React.FC = () => {
  const { showAlertCuration } = useFlags()
  const { showNullData, setShowNullData } = useUserPreferences()

  if (!showAlertCuration) return null

  return (
    <Tooltip title="Toggles display of rows with null location or disease">
      <Box sx={{ textAlign: "center" }}>
        <Typography
          variant="caption"
          sx={{
            display: "block",
            fontSize: 9,
            fontWeight: 800,
            color: extraColors.hint,
            textTransform: "uppercase",
            mb: 0.5,
            letterSpacing: "0.05em",
          }}
        >
          Curation Tools
        </Typography>
        <ToggleRow>
          <Typography
            variant="small1Bold"
            sx={{
              color: extraColors.status.green,
              opacity: !showNullData ? 1 : 0.4,
              fontSize: 10,
            }}
          >
            Hide Nulls
          </Typography>
          <SwitchStyled
            checked={showNullData}
            onChange={e => setShowNullData(e.target.checked)}
            color={"secondary"}
            size="small"
          />
          <Typography
            variant="small1Bold"
            sx={{
              color: extraColors.status.navy,
              opacity: !showNullData ? 0.4 : 1,
              fontSize: 10,
            }}
          >
            Show Nulls
          </Typography>
        </ToggleRow>
      </Box>
    </Tooltip>
  )
}
